/**
 * MethodologyEvents
 * Created by Esteban on 5/25/15.
 */

module media.hrratings.events {
    export class MethodologyEvents extends createjs.Event {
        static METHODOLOGY_DOCUMENTS:string = "MethodologyEvents.methodology_documents";
    }
}